import { isBefore, set } from 'date-fns';
import { useCallback } from 'react';
import { type DatePickerDateType, getDateType } from 'ui';
import { SLOT_INTERVAL_MINUTES } from './time-slot';
import { useGetStartTimeSlots } from './useGetStartTimeSlots';

export const useGetDefaultStartTimeSlot = () => {
  const getStartTimeSlots = useGetStartTimeSlots();

  return useCallback(
    (startDate: DatePickerDateType): Date => {
      const now = new Date();
      const roundedMinutes = Math.ceil(now.getMinutes() / SLOT_INTERVAL_MINUTES) * SLOT_INTERVAL_MINUTES;
      const defaultStartDateTime = set(getDateType(startDate), {
        hours: now.getHours(),
        milliseconds: 0,
        minutes: roundedMinutes,
        seconds: 0,
      });

      if (!isBefore(defaultStartDateTime, now)) {
        return defaultStartDateTime;
      }

      const firstAvailableSlot = getStartTimeSlots(startDate).find((date) => !isBefore(date, now));
      return firstAvailableSlot ?? defaultStartDateTime;
    },
    [getStartTimeSlots],
  );
};
